(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("ReactActivity", ["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactActivity"] = factory(require("react"));
	else
		root["ReactActivity"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__297__) {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 930:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* reexport */ Bounce_Bounce)
});

;// CONCATENATED MODULE: ./src/Bounce/Bounce.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
var ActivityIndicator = __webpack_require__(438);
// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
var getRelativeTime = __webpack_require__(531);
;// CONCATENATED MODULE: ./src/Bounce/Bounce.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var Bounce = function (_a) {
    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
    var renderSquares = function () {
        var res = [];
        for (var i = 1; i <= 3; i++) {
            res.unshift(external_react_.createElement("div", { key: i, style: {
                    animationDelay: (0,getRelativeTime/* getRelativeTime */.n)(speed, i / -10),
                } }));
        }
        return res;
    };
    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-bounce", speed: speed, defaultAnimationDuration: 0.8 }, rest), renderSquares()));
};
/* harmony default export */ const Bounce_Bounce = (Bounce);

;// CONCATENATED MODULE: ./src/Bounce/index.ts



/***/ }),

/***/ 843:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* reexport */ Digital_Digital)
});

;// CONCATENATED MODULE: ./src/Digital/Digital.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
var ActivityIndicator = __webpack_require__(438);
// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
var getRelativeTime = __webpack_require__(531);
;// CONCATENATED MODULE: ./src/Digital/Digital.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var Digital = function (_a) {
    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
    var rects = [];
    for (var i = 1; i <= 3; i++) {
        rects.unshift(external_react_.createElement("div", { key: i, style: {
                animationDelay: (0,getRelativeTime/* getRelativeTime */.n)(speed, i / -10),
            } }));
    }
    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-digital", defaultAnimationDuration: 0.8, speed: speed }, rest), rects));
};
/* harmony default export */ const Digital_Digital = (Digital);

;// CONCATENATED MODULE: ./src/Digital/index.ts



/***/ }),

/***/ 266:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* reexport */ Dots_Dots)
});

;// CONCATENATED MODULE: ./src/Dots/Dots.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
var ActivityIndicator = __webpack_require__(438);
// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
var getRelativeTime = __webpack_require__(531);
;// CONCATENATED MODULE: ./src/Dots/Dots.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var Dots = function (_a) {
    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-dots", speed: speed, defaultAnimationDuration: 0.8 }, rest),
        external_react_.createElement("div", { className: "rai-circle", style: { animationDelay: (0,getRelativeTime/* getRelativeTime */.n)(speed, -0.3) } }),
        external_react_.createElement("div", { className: "rai-circle", style: { animationDelay: (0,getRelativeTime/* getRelativeTime */.n)(speed, -0.2) } }),
        external_react_.createElement("div", { className: "rai-circle", style: { animationDelay: (0,getRelativeTime/* getRelativeTime */.n)(speed, -0.1) } })));
};
/* harmony default export */ const Dots_Dots = (Dots);

;// CONCATENATED MODULE: ./src/Dots/index.ts



/***/ }),

/***/ 831:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* reexport */ Levels_Levels)
});

;// CONCATENATED MODULE: ./src/Levels/Levels.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
var ActivityIndicator = __webpack_require__(438);
// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
var getRelativeTime = __webpack_require__(531);
;// CONCATENATED MODULE: ./src/Levels/Levels.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var Levels = function (_a) {
    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-levels", speed: speed, defaultAnimationDuration: 1.5 }, rest),
        external_react_.createElement("div", { className: "rai-levels-container" },
            external_react_.createElement("div", { className: "rai-bar" }),
            external_react_.createElement("div", { className: "rai-bar", style: { animationDelay: (0,getRelativeTime/* getRelativeTime */.n)(speed, -0.25) } }),
            external_react_.createElement("div", { className: "rai-bar", style: { animationDelay: (0,getRelativeTime/* getRelativeTime */.n)(speed, -0.4) } }))));
};
/* harmony default export */ const Levels_Levels = (Levels);

;// CONCATENATED MODULE: ./src/Levels/index.ts



/***/ }),

/***/ 874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* reexport */ Sentry_Sentry)
});

;// CONCATENATED MODULE: ./src/Sentry/Sentry.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
var ActivityIndicator = __webpack_require__(438);
// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
var getRelativeTime = __webpack_require__(531);
;// CONCATENATED MODULE: ./src/Sentry/Sentry.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var Sentry = function (_a) {
    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-sentry", speed: speed, defaultAnimationDuration: 0.8 }, rest),
        external_react_.createElement("div", { className: "rai-wave-container" },
            external_react_.createElement("div", { className: "rai-wave" })),
        external_react_.createElement("div", { className: "rai-wave-container" },
            external_react_.createElement("div", { className: "rai-wave", style: { animationDelay: (0,getRelativeTime/* getRelativeTime */.n)(speed, -0.4) } }))));
};
/* harmony default export */ const Sentry_Sentry = (Sentry);

;// CONCATENATED MODULE: ./src/Sentry/index.ts



/***/ }),

/***/ 752:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* reexport */ Spinner_Spinner)
});

;// CONCATENATED MODULE: ./src/Spinner/Spinner.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
var ActivityIndicator = __webpack_require__(438);
;// CONCATENATED MODULE: ./src/Spinner/Spinner.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var Spinner = function (props) {
    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-spinner", defaultAnimationDuration: 0.6 }, props),
        external_react_.createElement("div", { className: "rai-spinner-outer" }),
        external_react_.createElement("div", { className: "rai-spinner-inner" })));
};
/* harmony default export */ const Spinner_Spinner = (Spinner);

;// CONCATENATED MODULE: ./src/Spinner/index.ts



/***/ }),

/***/ 209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* reexport */ Squares_Squares)
});

;// CONCATENATED MODULE: ./src/Squares/Squares.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
var ActivityIndicator = __webpack_require__(438);
;// CONCATENATED MODULE: ./src/Squares/Squares.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var Squares = function (props) {
    var squares = [];
    for (var i = 1; i <= 3; i++) {
        squares.unshift(external_react_.createElement("div", { key: i, className: "rai-square", style: { animationDelay: "-" + i / 10 + "s" } }));
    }
    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-squares", defaultAnimationDuration: 0.8 }, props), squares));
};
/* harmony default export */ const Squares_Squares = (Squares);

;// CONCATENATED MODULE: ./src/Squares/index.ts



/***/ }),

/***/ 918:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* reexport */ Windmill_Windmill)
});

;// CONCATENATED MODULE: ./src/Windmill/Windmill.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
var ActivityIndicator = __webpack_require__(438);
;// CONCATENATED MODULE: ./src/Windmill/Windmill.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var Windmill = function (props) {
    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-windmill", defaultAnimationDuration: 0.8 }, props)));
};
/* harmony default export */ const Windmill_Windmill = (Windmill);

;// CONCATENATED MODULE: ./src/Windmill/index.ts



/***/ }),

/***/ 438:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* reexport */ ActivityIndicator_ActivityIndicator)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
var getRelativeTime = __webpack_require__(531);
;// CONCATENATED MODULE: ./src/shared/ActivityIndicator/ActivityIndicator.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var ActivityIndicator = function (_a) {
    var style = _a.style, _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.speed, speed = _c === void 0 ? 1 : _c, defaultAnimationDuration = _a.defaultAnimationDuration, color = _a.color, className = _a.className, _d = _a.animating, animating = _d === void 0 ? true : _d, children = _a.children, indicatorClassName = _a.indicatorClassName;
    if (!animating) {
        return null;
    }
    var animationDuration = (0,getRelativeTime/* getRelativeTime */.n)(speed, defaultAnimationDuration);
    return (external_react_.createElement("div", { "data-testid": "rai-activity-indicator", className: "rai-container " + indicatorClassName + (className ? " " + className : ""), style: __assign({ color: color, fontSize: size + "px", animationDuration: animationDuration }, style) }, children));
};
/* harmony default export */ const ActivityIndicator_ActivityIndicator = (ActivityIndicator);

;// CONCATENATED MODULE: ./src/shared/ActivityIndicator/index.ts



/***/ }),

/***/ 531:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ getRelativeTime)
/* harmony export */ });
var getRelativeTime = function (speed, delay) {
    return (1 / speed) * delay + "s";
};


/***/ }),

/***/ 297:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__297__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dots": () => (/* reexport safe */ _Dots__WEBPACK_IMPORTED_MODULE_0__.default),
/* harmony export */   "Bounce": () => (/* reexport safe */ _Bounce__WEBPACK_IMPORTED_MODULE_1__.default),
/* harmony export */   "Levels": () => (/* reexport safe */ _Levels__WEBPACK_IMPORTED_MODULE_2__.default),
/* harmony export */   "Sentry": () => (/* reexport safe */ _Sentry__WEBPACK_IMPORTED_MODULE_3__.default),
/* harmony export */   "Spinner": () => (/* reexport safe */ _Spinner__WEBPACK_IMPORTED_MODULE_4__.default),
/* harmony export */   "Squares": () => (/* reexport safe */ _Squares__WEBPACK_IMPORTED_MODULE_5__.default),
/* harmony export */   "Digital": () => (/* reexport safe */ _Digital__WEBPACK_IMPORTED_MODULE_6__.default),
/* harmony export */   "Windmill": () => (/* reexport safe */ _Windmill__WEBPACK_IMPORTED_MODULE_7__.default)
/* harmony export */ });
/* harmony import */ var _Dots__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(266);
/* harmony import */ var _Bounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(930);
/* harmony import */ var _Levels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(831);
/* harmony import */ var _Sentry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(874);
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(752);
/* harmony import */ var _Squares__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(209);
/* harmony import */ var _Digital__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(843);
/* harmony import */ var _Windmill__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(918);










})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});